import { useState } from 'react';
import { financingTabs } from '@/mocks/financing';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';

export default function FinancingSection() {
  const { ref, isVisible } = useScrollAnimation(0.1);
  const [activeTab, setActiveTab] = useState('salaries');

  const activeTabData = financingTabs.find((t) => t.id === activeTab);

  const scrollToContact = () => {
    const el = document.getElementById('contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="financement" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div ref={ref} className={`text-center transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            Financez votre prochain véhicule
          </h2>
          <p className="text-foreground-600 mt-3 max-w-2xl mx-auto text-sm md:text-base">
            Easy Car vous accompagne dans la constitution de votre dossier de financement afin de simplifier votre achat.
          </p>
        </div>

        {/* Tabs */}
        <div className="mt-8 md:mt-12 flex flex-wrap justify-center gap-2">
          {financingTabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`px-5 py-2.5 rounded-full font-label text-sm font-medium transition-all whitespace-nowrap ${
                activeTab === tab.id
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-200 text-foreground-600 hover:bg-background-300'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Tab Content */}
        <div className={`mt-8 max-w-3xl mx-auto transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="bg-white rounded-lg border border-background-200 p-6 md:p-8">
            <h3 className="font-heading font-bold text-lg text-foreground-900 mb-4">
              Documents requis — {activeTabData?.label}
            </h3>
            <ul className="space-y-3">
              {activeTabData?.documents.map((doc, idx) => (
                <li key={idx} className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line w-5 h-5 flex items-center justify-center text-primary-500 mt-0.5 shrink-0" />
                  <span className="text-foreground-700 text-sm leading-relaxed">{doc}</span>
                </li>
              ))}
            </ul>

            <div className="mt-6 p-4 bg-background-100 rounded-md border border-background-200">
              <p className="text-foreground-600 text-sm">
                <i className="ri-mail-line w-4 h-4 inline-flex items-center justify-center mr-1" />
                Envoyez votre dossier complet au format PDF à{' '}
                <a href="mailto:easycar974@gmail.com" className="text-primary-600 font-medium hover:underline">
                  easycar974@gmail.com
                </a>{' '}
                ou venez directement en agence.
              </p>
            </div>
          </div>
        </div>

        {/* CTAs */}
        <div className={`flex flex-col sm:flex-row items-center justify-center gap-3 mt-8 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <button
            onClick={scrollToContact}
            className="px-6 py-3 rounded-md bg-primary-500 text-white font-label font-semibold text-sm hover:bg-primary-600 transition-all whitespace-nowrap"
          >
            Préparer mon dossier
          </button>
          <a
            href="tel:+262692505551"
            className="px-6 py-3 rounded-md border border-foreground-300 text-foreground-700 font-label font-medium text-sm hover:border-primary-500 hover:text-primary-600 transition-all whitespace-nowrap"
          >
            Appeler Easy Car
          </a>
        </div>
      </div>
    </section>
  );
}